import React, { PropsWithChildren } from "react";

type Props = {
  href?: string;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  icon?: string;
  variant?: "primary" | "secondary" | "small" | "small-caps" | "icon-only" | "text";
  color?: string;
  className?: string;
  type?: "button" | "submit" | "reset";
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  iconRight?: boolean;
};

export const Button: React.FC<Props> = ({
  href,
  label,
  ariaLabel,
  disabled,
  icon,
  variant,
  color,
  type,
  className,
  onClick,
  iconRight = false,
  ...props
}) => {
  const classes = `${className || ""} button ${
    variant === "icon-only"
      ? "icon-only"
      : variant === "primary" && color === "text-white"
      ? "button--primary button--text-white"
      : variant === "primary"
      ? "button--primary"
      : variant === "secondary" && color === "outline-white"
      ? "button--secondary button--outline-white"
      : variant === "secondary"
      ? "button--secondary"
      : variant === "small"
      ? "button--small"
      : variant === "small-caps"
      ? "button--small button--small-caps"
      : variant === "text"
      ? "button button--text"
      : ""
  } ${color ? `button--${color}` : ""}`;

  const isSmall = variant === "small" || variant === "small-caps";
  const outerClass = isSmall ? className + " button-small-wrap" : classes;

  const Wrapper: React.FC<PropsWithChildren> = ({ children }) => {
    return href ? (
      <a href={href} className={outerClass} title={label} onClick={onClick} {...props}>
        {isSmall ? <span className={classes}>{children}</span> : children}
      </a>
    ) : (
      <button className={outerClass} aria-label={ariaLabel} disabled={disabled} type={type} onClick={onClick} {...props}>
        {isSmall ? <span className={classes}>{children}</span> : children}
      </button>
    );
  };

  return (
    <Wrapper>
      {icon && (
        <svg
          className={`icon ${
            variant !== "icon-only" && !iconRight
              ? "icon-left"
              : variant !== "icon-only" && iconRight
              ? "icon-right"
              : ""
          }`}
        >
          <use xlinkHref={`#${icon}`} />
        </svg>
      )}
      {variant === "icon-only" ? "" : label}
    </Wrapper>
  );
};
